import React, { FunctionComponent, useContext } from "react";

import { TvSeriesDashboardContext } from "../TvSeriesDashboardProvider";
import { EpisodePageProvider } from "./episode/context/EpisodePageProvider";
import { EpisodeInfo } from "./episode/info/EpisodeInfo";
import { EpisodeVersionListProvider } from "./episode/version-listing/context/EpisodeVersionListProvider";
import { EpisodeVersionListing } from "./episode/version-listing/EpisodeVersionListing";
import { SeasonPageProvider } from "./season/context/SeasonPageProvider";
import { SeasonEpisodeListingProvider } from "./season/episode-listing/context/SeasonEpisodeListingProvider";
import { EpisodeListing } from "./season/episode-listing/EpisodeListing";
import { SeasonInfo } from "./season/info/SeasonInfo";
import { TvSeriesPageProvider } from "./tv-series/context/TvSeriesPageProvider";
import { TvSeriesInfo } from "./tv-series/info/TvSeriesInfo";
import { SeasonListing } from "./tv-series/season-listing/SeasonListing";

export const TvSeriesDashboardPages: FunctionComponent = () => {
    const { currentPage } = useContext(TvSeriesDashboardContext);

    switch (currentPage) {
        case "tvSeriesPage":
            return (
                <TvSeriesPageProvider>
                    <TvSeriesInfo />
                    <SeasonListing />
                </TvSeriesPageProvider>
            );
        case "seasonPage":
            return (
                <SeasonPageProvider>
                    <SeasonEpisodeListingProvider>
                        <SeasonInfo />
                        <EpisodeListing />
                    </SeasonEpisodeListingProvider>
                </SeasonPageProvider>
            );
        case "episodePage":
            return (
                <EpisodePageProvider>
                    <EpisodeInfo />
                    <EpisodeVersionListProvider>
                        <EpisodeVersionListing />
                    </EpisodeVersionListProvider>
                </EpisodePageProvider>
            );

        default:
            return <></>;
    }
};
